module.exports = __webpack_public_path__ + "img/logo-ifce.c592d398.png";